import type { ExistingPlace, PublicationFormat, ReducedPlace } from './publisher';
import type { Tab } from './publisher/UI';

export const enum PublicationTab {
  'LIST' = 'LIST',
  'CALENDAR' = 'CALENDAR',
}

export type PublicationTabData = Tab<PublicationTab>;

export const enum PublicationStatus {
  'NEW' = 1, // Новая, технический статус для бэкенда
  'WAIT_MODERATION' = 2, // Ожидает модерации админом (публикации / креатива ?)
  'WAIT_PUBLISHER_APPROVE' = 3, // Ожидает подтверждения паблишером
  'WAIT_TIME' = 4, // Ожидает наступления точного времени публикации
  'WAIT_URL' = 5, // Ожидает отправки ссылки на публикацию паблишером
  'FULFILLED' = 7, // Выполнена публикация. Рекламодатель подтвердил размещение
  'FINISHED' = 8, // Публикация завершена
  'ERROR' = 100, // Ошибка, технический статус для бэкенда
  'DECLINED_MODERATION' = 101, // Отклонена при модерации админом (публикации / креатива ?)
  'DECLINED_PUBLISHER' = 102, // Отклонена паблишером
  'CANCELLED' = 103, // Отменилась
}

export const enum PublicationCommentType {
  'PUBLISHER' = 'publisher',
  'ADVERTISER' = 'advertiser',
  'ADMIN' = 'admin',
}

export const enum PublicationCommentStatus {
  NEW = 1,
  UNREAD = 2,
  READ = 3,
}

export type PublicationComment = {
  id?: number;
  type: PublicationCommentType;
  comment: string;
  status: PublicationCommentStatus;
};

export type DatePlan = {
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
};

export type PublicationDatePlan = DatePlan & {
  exactDate: string;
};

export type PublicationDatePlanView = {
  datePlanFromLabel: string;
  datePlanToLabel: string;
  datePlanFromTimeLabel: string;
  datePlanToTimeLabel: string;
  datePlanTime: string;
};

type PublicationCommon = {
  format: PublicationFormat;
  datePlan: PublicationDatePlan;
};

export type PublicationBody = PublicationCommon & {
  place: ReducedPlace | null;
};

export interface Publication extends PublicationCommon {
  id: number;
  status: PublicationStatus;
  url: string;
  order?: {
    id: number;
    name: string;
  };
  place: ExistingPlace;
  advertId: number;
  dateFact: string | null;
  comments: PublicationComment[];
  screenshotUrl: string;
  format: PublicationFormat;
  datePlan: PublicationDatePlan;
}
